var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11111 3.77567C9.26452 3.77567 9.38889 3.89974 9.38889 4.05278V4.607H6.61111V4.05278C6.61111 3.89974 6.73548 3.77567 6.88889 3.77567H9.11111ZM5.77778 4.05278V4.607H3.41667C3.18655 4.607 3 4.7931 3 5.02267C3 5.25224 3.18655 5.43834 3.41667 5.43834H4.11111V12.947C4.11111 13.5592 4.60857 14.0554 5.22222 14.0554H10.7778C11.3914 14.0554 11.8889 13.5592 11.8889 12.947V5.43834H12.5833C12.8135 5.43834 13 5.25224 13 5.02267C13 4.7931 12.8135 4.607 12.5833 4.607H10.2222V4.05278C10.2222 3.4406 9.72476 2.94434 9.11111 2.94434H6.88889C6.27524 2.94434 5.77778 3.4406 5.77778 4.05278ZM11.0556 5.43834V12.947C11.0556 13.1 10.9312 13.2241 10.7778 13.2241H5.22222C5.06881 13.2241 4.94444 13.1 4.94444 12.947V5.43834H11.0556ZM8.83333 6.68534L8.83333 11.9505C8.83333 12.18 9.01988 12.3661 9.25 12.3661C9.48012 12.3661 9.66667 12.18 9.66667 11.9505L9.66667 6.68534C9.66667 6.45577 9.48012 6.26967 9.25 6.26967C9.01988 6.26967 8.83333 6.45577 8.83333 6.68534ZM6.33333 11.9505V6.68534C6.33333 6.45577 6.51988 6.26967 6.75 6.26967C6.98012 6.26967 7.16667 6.45577 7.16667 6.68534V11.9505C7.16667 12.18 6.98012 12.3661 6.75 12.3661C6.51988 12.3661 6.33333 12.18 6.33333 11.9505Z",
    fill: "#7A7B84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.001ca2acf7cf80dddb6170a2d42518cd.svg";
export { ForwardRef as ReactComponent };